import { Application } from '../config'
import {
  NewReservationConfirmationStep,
  NewReservationCompletedStep
} from '../pages'
import NewReservationLayout from '../containers/NewReservationLayout'

export const newReservationUrls = {
  newReservationBusStopsStep: '/new-reservation/bus-stops',
  newReservationDateStep: '/new-reservation/date',
  newReservationRouteOptionsStep: '/new-reservation/route-options',
  newReservationConfirmationStep: '/new-reservation/confirmation',
  newReservationCompletedStep: '/new-reservation/completed'
}

const { isIframe } = Application

export const newReservationFlowUrls = [
  newReservationUrls.newReservationBusStopsStep,
  newReservationUrls.newReservationDateStep,
  newReservationUrls.newReservationRouteOptionsStep
]

export const newReservationRoutes = [
  { content: NewReservationLayout, url: newReservationFlowUrls, isAuthenticated: isIframe ? false : true },
  { content: NewReservationConfirmationStep, url: newReservationUrls.newReservationConfirmationStep, isAuthenticated: isIframe ? false : true },
  { content: NewReservationCompletedStep, url: newReservationUrls.newReservationCompletedStep, isAuthenticated: isIframe ? false : true }
]
